import { IonList, IonItem, IonLabel, IonIcon, IonCard, IonText } from "@ionic/react";
import { bookmarkOutline, personOutline } from "ionicons/icons";
import React from "react";
import { useSelector } from "react-redux";
import { Location } from "../../../@types/location";
import { LocationAvatar } from "../../../components/Location/LocationAvatar";
import { selectLocations } from "../../../store/locations/selectors/selectLocations";

export const ListSection: React.FC = () => {
  const locations = useSelector(selectLocations);

  /*   const ListItem = (childs: any) => (
    <>
      {(childs || []).map((location: Location) => (
        <>
          <IonItem routerLink={`/app/rrhh/locations/${location.id}`}>
            <IonLabel>
              <h3>{location.name}</h3>
            </IonLabel>
          </IonItem>
          {location.childs?.length && <ListItem childs={location.childs} />}
        </>
      ))}
    </>
  ); */
  return (
    <section>
      {/* <ListItem childs={locations} /> */}

      {locations.map((location) => (
        <IonCard key={location.id}>
          <IonItem routerLink={`/app/tic/instalaciones/detalle/${location.id}`}>
            <LocationAvatar location={location} />
            <IonLabel>
              <h2 style={{ fontWeight: 500 }}>
                {location.name} ({location.code})
              </h2>
              <p>{location.organization?.name}</p>
            </IonLabel>
            <IonText slot="end">
              <IonIcon icon={personOutline}></IonIcon>
              <span className="ion-margin-start">{location.usersCount}</span>
            </IonText>
          </IonItem>
        </IonCard>
      ))}
    </section>
  );
};
